<template>
    <div class="vm-action-feed-setting" :class="[browser_size]">
        <template v-if="status == 1">
            <div class="item flex-box flex-a-center flex-bet fs16 black-8 gl-hover-text" @click="set">
                <span>{{$t('c.ActionFeedSetting.text1')}}</span>
                <!-- <switches theme="custom" color="purple" v-model="show_album"></switches> -->
                </div>
            <div class="line mt20 mb20"></div>
            <div class="item flex-box flex-a-center flex-bet fs16 black-8 gl-hover-text" @click="tab(2)">
                <span>{{$t('c.ActionFeedSetting.text2')}}</span>
                <i class="afd afd-arrow-right fs14 black-3"></i>
            </div>
        </template>
        <!-- <div v-if="status == 2" class="item flex-box flex-a-center flex-bet fs14 black-8">
            <avatar v-if="session_user" class="wh24" :user="session_user"/>
            <span class="black-3 fs14">取消</span>
        </div> -->
         <div v-if="status == 2" class="item flex-box flex-a-center flex-bet fs14 black-8 gl-hover-text" @click="report">
            <span>{{$t('c.ActionFeedSetting.text3')}}</span>
        </div>
    </div>
</template>

<script>
import { POST_UPDATE_USER_FEED_SETTING } from "@/api/config";

import { mapState } from "vuex";
export default {
  name: "action-feed-setting",
  props: {
    params: {},
  },
  data() {
    return {
        status:1
    };
  },
  inject:['app_action_sheet'],
  computed: {
    ...mapState("app", ["browser_size",'session_user']),
  },
  beforeDestroy(){
  },
  mounted() {
  },
  methods: {
    tab(n) {
        this.status = n
    },
    async set(){
        if(this.$http.is_run(POST_UPDATE_USER_FEED_SETTING)){
            return false
        }
        let data = await this.$http.$axios(POST_UPDATE_USER_FEED_SETTING,{
            in_blacklist: 1,
            user_id:this.params.user_id
        })
        if(data.ec != 200){
            this.$notify({
                title: data.em,
                group: 'error',
            })
            return false
        }
        this.app_action_sheet('close')
        this.$bus.$emit("FEED_REFRESH");
    },
    // set(){

        // this.app_action_sheet('close')
        // this.$bus.$emit("FEED_REFRESH");
    // },
    report(){
      this.app_action_sheet('close')
      this.$modal.show(
          () => import("@/components/ModalItemList"),{
            param:{
              object_type:'post',
              object_id: this.params.post_id
            }
          },
          {
              pivotY: 0.5,
              classes: "v--modal-msg-order v--modal",
              height: "auto",
              width: 200,
              adaptive: false,
              scrollable: true,
          }
      );
    },
    report_old(){
        this.app_action_sheet('close')
        this.$modal.show('dialog', {
            title: this.$t('c.dialog.text6'),
            buttons: [
            {
                title: this.$t('c.dialog.text1'),
                handler: () => {
                this.$modal.hide('dialog');
                },
            },
            {
                title: this.$t('c.dialog.text2'),
                handler: async () => {
                let text = `[${location.origin}/p/${this.params.post_id}] 你好，举报此内容，理由为`;
                this.$modal.hide('dialog');
                this.$router.push(
                    `/message/27f7cea2370d11e8ae8852540025c377?is_keyboard_up=1&text=${text}`
                );
                },
            },
            ],
        });
    },
    // async submit(){
    //     if(this.$http.is_run(POST_USER_FEED_SETTINGS)){
    //         return false
    //     }
    //     let data = await this.$http.$axios(POST_USER_FEED_SETTINGS)
    //     if(data.ec != 200){
    //         this.$notify({
    //             title: data.em,
    //             group: 'error',
    //         })
    //         return false
    //     }

    //     this.status_pre = 'after'
    //     // this.my_vote_pre = data.data.my_vote;
    //     this.vote_pre = data.data.vote;
    //     this.my_vote_pre = data.data.vote.my_vote;

    // },
  }
};
</script>

<style lang="stylus" scoped>
.vm-action-feed-setting {
    background: $white;
    padding:24px 0px;
    box-sizing: border-box;
    min-width:350px;
    // transform:translate(0,100%);
    // transition:all .2s ease-out;
    // &.on{
    //     transform:translate(0,0);
    // }
    .line{
      background:#F7F7F7;
      margin-left:16px;
      margin-right:16px;
      width:calc(100% - 32px);
      box-sizing:border-box;
    }
    .item{
      padding:0 16px;
      margin-bottom:24px;
      &:last-child{
        margin-bottom:0px;
      }
    }
    &.small {
        min-width:auto;
        background: $white;
        border-radius:8px 8px 0 0;
        padding:24px 0 40px 0;
        position:fixed;
        left:0;
        width:100%;
        bottom:0;
    }
    &.safe-space{
      padding-bottom:$safe-space;
    }
}
</style>
